<template>
    <div id="mainBlock">
            <!-- 変更確認ポップアップの表示 -->
        <Confirm
            ref="confirm"
            @cancel="modifyStatusDelte"
            @execution="modifyStatusChange"
            :message="confirmMessage"
            :subMessage="confirmSubMessage"
            canselButtonName="キャンセル"
            executionButtonName="変更する"
        />
        <!-- エラー確認ポップアップの表示 -->
        <Alert
            ref="Alert"
            @confirmFinished="confirmFinished"
            :message="alertMessage"
            :subMessage="alertSubMessage"
            :errorFlag = "errorFlag"
        />
        <div id="blackPanel"></div>
        <article v-if="requestErrorJudge">
            <section>
                <div id="subHeader">
                    <h2 v-if="siteInfo !== null">{{siteInfo[0]['site_name']}}</h2>
                </div>
            </section>
            <!-- パンくず -->
            <div class="breadcrumb">
                <!-- PC/タブレット -->
                <ul class="breadcrumbs-one">
                    <li><router-link :to="routerLink" class="setting-message">設定</router-link></li>
                    <li>
                        <a href="#" v-if="!linkDisabled" @click="cameraListsDisplay(true)" class="setting-message">カメラ設定</a>
                        <a v-else class="setting-message current" tabindex="-1">カメラ設定</a>
                    </li>
                    <li class="breadcrumb-camera-name">
                        <a v-if="!linkDisabled" tabindex="-1" class="current camera-name">{{this.cameraName}}</a>
                    </li>
                </ul>
                <!-- スマホ -->
                <ul class="breadcrumbs-one-mb">
                    <li><router-link v-if='mbPageName !== "カメラ設定"' :to="routerLink" tabindex="-1">設定</router-link></li>
                    <li><a href="#" v-if='mbPageName === "カメラ設定"' @click="cameraListsDisplay(true)" tabindex="-1">カメラ設定</a></li>
                </ul>
            </div>

            <div class="l-main">
                <!-- カメラ詳細画面コンポーネントの呼び出し -->
                <SettingCamDetailsComponent
                    v-if="cameraSettingFlg"
                    ref="execModifySettingInfo"
                    @cameraListsDisplay = "cameraListsDisplay"
                    @settingChangeLoadStart="settingChangeLoadStart"
                    @settingChangeLoadFinish="settingChangeLoadFinish"
                    @displaySettingConfirm="displaySettingConfirm"
                    @showResultMessage="showResultMessage"
                    :cameraInfo="selectedCameraInfo"
                    :siteInfo="selectedSiteInfo"
                    :deviceInfo="deviceInfo"
                    :timezoneInfo="timezoneInfo"
                />
                <!-- 「カメラ詳細設定画面」に遷移した際に非表示状態にする -->
                <div v-if="!cameraSettingFlg" class="setting-area" id="setting-area">
                    <!-- 説明欄 -->
                    <div class="desc-wrapper">
                        <p class="simple-desc">
                            カメラの設定変更を行う場合は「詳細設定」ボタンを、カメラに直接アクセスし設定を変更を行う場合は「カメラ直接操作」ボタンを押下してください。
                            <br>カメラの録画状態を変更した場合、反映までに時間がかかる場合がございます。
                        </p>
                    </div>

                    <!-- PC用のテーブル -->
                    <div class="camera-table">
                        <div class="tr thead">
                            <div class="td name">カメラ名称</div>
                            <div class="td order">表示順</div>
                            <div class="td termid">端末ID</div>
                            <div v-if="settingCamRecOperation" class="td status">状態</div>
                            <div class="td btn_status">各種操作</div>
                            <div v-if="settingCamRecOperation" class="td btn_detailsettings"></div>
                            <div v-if="settingCamOperation" class="td btn_cameraui"></div>
                        </div>
                        <div class="tr tbody" v-for="(camerainfos, key) in cameraInfo" :key="camerainfos + key">
                            <div class="td name">{{ camerainfos.description }}</div>
                            <div class="td order"><span>表示順</span><span>{{camerainfos.sort === "0" ? "" : camerainfos.sort}}</span></div>
                            <div class="td termid"><span>端末ID</span><span>{{ camerainfos.term_id }}</span></div>
                            <div v-if="settingCamRecOperation" class="td status">
                                <span>状態</span>
                                <span v-if="camerainfos.is_recording" class="recording" >録画中</span>
                                <span v-else class="suspending">停止中<br><span class="camera-no-setting" v-if="camerainfos.camera_host === ''">カメラURL未設定</span></span>
                            </div>
                            <div v-if="settingCamRecOperation" class="td btn_status">
                                <a v-if="camerainfos.is_recording" @click="confirmRecord('stop', camerainfos.term_id)" class="-stop">録画停止</a>
                                <a v-if="camerainfos.camera_host !== '' && !camerainfos.is_recording" class="-play" @click="confirmRecord('start', camerainfos.term_id)">録画開始</a>
                                <a v-if="camerainfos.camera_host === '' && !camerainfos.is_recording" class="-play passive" >録画開始</a>
                            </div>
                            <div class="td btn_detailsettings"><a @click="cameraDetailDisplay(camerainfos, siteInfo[0])">詳細設定</a></div>
                            <div v-if="settingCamOperation" class="td btn_cameraui">
                                <a v-if="camerainfos.camera_host!==''" :href="camerainfos.camera_host" target="_blank" rel="noopener noreferrer">カメラ直接操作</a>
                                <a v-else class="passive">カメラ直接操作</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    </div>
</template>
<script>
const apiUrl = process.env.VUE_APP_API_apiUrl;

import SettingCamDetailsComponent from './SettingCamDetailsComponent'
import isMobile from '../../js/modules/componentDeviceUtility.js'
import Confirm from '../modal/Confirm'
import Alert from '../modal/Alert'
const logoutUrl = process.env.VUE_APP_TOP_PAGE_URL;

export default {
    name: 'SettingCamListsComponent',
    data(){
        return {
            // カメラ詳細設定画面を表示/非表示するための判断フラグ
            cameraSettingFlg: false,
            selectedCameraInfo: null,
            selectedSiteInfo: null,
            // APIをコールする際に一時的にバッファする
            infoCallingApi: null,
            deviceInfo: null,
            timezoneInfo: null,
            // ローディング画面を表示するための値
            is_show: false,

            // 子コンポーネントから確認ポップアップ表示が着火されて、どこの子コンポーネントから呼び出されたのか判定するためのフラグ
            // 1: SettingCamDetailsComponent.vueからの呼び出し
            settingConfirmDisplayFlg: 0,

            // 子コンポーネントからの呼び出しで、確認する対象（録画ボタン確認や設定変更確認）によって表示文言を変更するための値
            confirmMessage: "",
            confirmSubMessage: "",
            routerLink: '/settings?site_no=' + this.$store.getters['auth/getSiteNo'],

            // 子コンポーネントからの呼び出しで、録画状態を管理するためのフラグ
            recordStatusFlg: "",

            // カメラ一覧画面から録画・停止を選択した端末を格納
            selectedTermId: "",
            // エラーメッセージ用の変数
            alertMessage: '',
            alertSubMessage: '',
            errorFlag: false,

            conrfirmResult: {},
            // 非同期処理で呼び出したapiのカウント用の変数
            apiCnt: 0,
            // スマホ判定用の変数
            isMb: isMobile.isMobile(),
            // タブレット判定用の変数
            // パンくずのaタグの活性/非活性を操作（初期は"カメラ設定"を表示）
            linkDisabled: true,
            // パンくずで表示する端末名を格納
            cameraName: "",
            // スマホ用のパンくずで表示する文言を判定するための変数
            mbPageName: "",
            // ウィンドウのサイズを保持するために使用
            windowSizeWidth: window.innerWidth,
            requestErrorJudge: false,
        }
    },
    props:{
        siteInfo:{
            type: Array
        },
        cameraInfo:{
            type: Array
        }
    },
    components: {
        SettingCamDetailsComponent,
        Confirm,
        Alert,
    },
    methods: {
        //**********************************************************/
        // 変更確認ポップアップの表示後、キャンセルを押した場合の処理
        /**********************************************************/
        modifyStatusDelte: function () {
            // 以下、録画状態や設定画面の状態の有無を管理しているフラグを初期化する処理
            this.settingConfirmDisplayFlg = 0;
            this.recordStatusFlg = ""
        },
        //**********************************************************/
        // 変更確認ポップアップの表示後、適用された後の処理実行とポップアップ非表示処理
        /**********************************************************/
        modifyStatusChange: function () {
            // 録画状態変更確認をした際に発火する処理の条件分岐
            if(this.recordStatusFlg !== "" && this.selectedTermId !== ""){
              // 子コンポーネントの録画停止/開始処理を実行
              this.recordSwicher(this.recordStatusFlg);
            }
            // 設定画面変更（電圧監視ウィジェットの設定なども含む）確認をした際に発火する処理の条件分岐
            else{
                if(this.settingConfirmDisplayFlg === 1){
                    // 子コンポーネントの設定変更処理を実行
                    this.$refs.execModifySettingInfo.modifySettingStatusChange();
                }
            }
            // 確認ポップアップ非表示
            this.$refs.confirm.hiddenConfirm();
            // ローディングスタート
            this.$emit('loadStart');

            // 以下、録画状態や設定画面の状態を管理しているフラグを初期化する処理
            this.settingConfirmDisplayFlg = 0;
            this.recordStatusFlg = ""
        },
        //**********************************************************/
        // 設定画面変更確認ポップアップの表示のための処理
        /**********************************************************/
        displaySettingConfirm: async function(){
            this.settingConfirmDisplayFlg = await 1;
            this.confirmMessage = await "設定更新";
            this.confirmSubMessage = await "設定を変更します。よろしいでしょうか？";
            // 確認ポップアップ表示
            this.$refs.confirm.showConfirm();
        },
        //**********************************************************/
        // 録画停止開始処理を確認するための確認ポップアップ表示処理
        // 【TODO】カメラ詳細設定のほうの録画処理を削除後にリファクタリングすること
        /**********************************************************/
        // 引数
        // recordStatus: 録画状態を管理しているステータス
        /**********************************************************/
        confirmRecord: function(recordStatus, termId){
            this.selectedTermId = termId;
            if(recordStatus === "start"){
                this.displayRecordConfirmStart();
            }else{
                this.displayRecordConfirmStop();
            }
        },
        //**********************************************************/
        // 録画開始処理確認ポップアップの表示のための処理
        // 【TODO】カメラ詳細設定のほうの録画処理を削除後にリファクタリングすること
        /**********************************************************/
        displayRecordConfirmStart: async function(){
            this.recordStatusFlg = await "start"
            this.confirmMessage = await "録画状態変更";
            this.confirmSubMessage = await "録画を開始します。よろしいでしょうか？";
            // 確認ポップアップ表示
            this.$refs.confirm.showConfirm();
        },
        //**********************************************************/
        // 録画停止処理確認ポップアップの表示のための処理
        // 【TODO】カメラ詳細設定のほうの録画処理を削除後にリファクタリングすること
        /**********************************************************/
        displayRecordConfirmStop: async function(){
            this.recordStatusFlg = await "stop"
            this.confirmMessage = await "録画状態変更";
            this.confirmSubMessage = await "録画を停止します。よろしいでしょうか？";
            // 確認ポップアップ表示
            this.$refs.confirm.showConfirm();
        },
        //**********************************************************/
        // 録画開始停止処理
        /**********************************************************/
        // 引数
        // recordType: 録画停止開始処理のタイプ
        /**********************************************************/
        recordSwicher: async function(recordStatus){
            var queries = { live_access_token: this.$store.getters['auth/getLiveAccessToken'] };
            // 録画停止開始のための条件分岐
            if(recordStatus === "start"){
                // 録画開始APIをコール
                await this.callApiForInfo('recorder/' + this.siteInfo[0].site_no + '/' + this.selectedTermId + '/status', "put", queries)
            }else{
                // 録画停止APIをコール
                this.callApiForInfo('recorder/' + this.siteInfo[0].site_no + '/' + this.selectedTermId + '/status', "delete", queries)
            }
        },
        //**********************************************************/
        // 録画開始・録画停止用API実施
        /**********************************************************/
        callApiForInfo: async function(param, method, queries){
            // 関数return値を配置する変数
            var isApiData = "";
            await this.$store.dispatch('requestApi/' + method + 'ApiInfoAction', {
                url: apiUrl + param,
                params: queries
            })
            // 以下「eslint-disable-line」を使用することにより、不要なバリデーションを除外する
            .then(response => { // eslint-disable-line
                this.infoCallingApi = this.$store.getters['requestApi/' + method + 'ApiInfo'];
                isApiData = this.infoCallingApi;

                // ローディングストップ
                this.$emit('loadFinish');

                if (method === 'put') {
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: true,
                        message:"録画成功",
                        sub_message:"録画を開始しました。",
                        errorFlag: false
                    });
                } else if (method === 'delete') {
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: true,
                        message:"録画停止成功",
                        sub_message:"録画を停止しました。",
                        errorFlag: false
                    });
                }
            }, error => {// eslint-disable-line
                // ローディングストップ
                this.$emit('loadFinish');
                if (error == "Error: Request failed with status code 401") {
                    sessionStorage.clear();
                    window.localStorage.removeItem('TodoApp');
                    this.showResultMessage({
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"エラー",
                        sub_message:"トップページに戻ります。",
                        errorFlag: true
                    });
                } else if (error == "Error: Request failed with status code 403") {
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: true,
                        execFlg: false,
                        message:"権限エラー",
                        sub_message:"アクセス権がありません。",
                        errorFlag: true
                    });
                } else {
                    if (method === 'put') {
                        this.showResultMessage({
                            transitionLogoutPageFlg: false,
                            transitionTopPageFlg: false,
                            execFlg: false,
                            message:"録画失敗",
                            sub_message:"録画を開始できませんでした。カメラURLをご確認ください。",
                            errorFlag: true
                        });
                    } else if (method === 'delete') {
                        this.showResultMessage({
                            transitionLogoutPageFlg: false,
                            transitionTopPageFlg: false,
                            execFlg: false,
                            message:"録画停止失敗",
                            sub_message:"録画を停止できませんでした。カメラURLをご確認ください。",
                            errorFlag: true
                        });
                    }
                }
            })
            return isApiData
        },
        //**********************************************************/
        // routerをリロードする処理
        // 【TODO】カメラ詳細設定のほうの録画処理を削除後にリファクタリングすること
        /**********************************************************/
        loadBrowser: function(){
            window.location.href = "./camera?site_no=" + this.$store.getters['auth/getSiteNo'];
        },
        /****************************************************************/
        // サムネイルを全て読み込み後にローディングを開始する処理
        /****************************************************************/
        loadingStarted(){
            this.$emit('loadStart');
            document.getElementById('l-main').style.display = "none"
        },
        /****************************************************************/
        // サムネイルを全て読み込み後にローディングを終了する処理
        /****************************************************************/
        loadingFinished(){
            this.$emit('loadFinish');
            document.getElementById('l-main').style.display = "inherit"
        },
        /****************************************************************/
        // 子に渡すようのローディングを開始する処理
        /****************************************************************/
        settingChangeLoadStart() {
            this.$emit('loadStart');
        },
        /****************************************************************/
        // 子に渡すようのローディングを終了する処理
        /****************************************************************/
        settingChangeLoadFinish() {
            this.$emit('loadFinish');
        },
        //**********************************************************/
        // カメラ設定詳細画面を表示するための関数
        // SettingCamDetailsComponentコンポーネントを表示するためにFlgを変更 & SettingCamDetailsComponentコンポーネントに引数情報を受け渡す
        /**********************************************************/
        cameraDetailDisplay(camerainfos, siteinfos){
            this.mbPageName = "カメラ設定";
            this.linkDisabled = false;
            this.cameraName = camerainfos.description;
            this.cameraSettingFlg   = true;
            this.selectedCameraInfo = camerainfos;
            this.selectedSiteInfo   = siteinfos;
        },
        //**********************************************************/
        // カメラ設定詳細画面からカメラ設定一覧画面に戻るために着火する関数（SettingCamDetailsComponentコンポーネントから呼び出される）
        // SettingCamDetailsComponentコンポーネントからのみ実行できるように引数情報を条件に内容着火
        /**********************************************************/
        cameraListsDisplay(execFlg){
            if(execFlg){
                this.mbPageName = "";
                this.cameraName = "";
                this.linkDisabled = true;
                this.cameraSettingFlg = false
            }
        },
        //**********************************************************/
        // 機種情報取得APIの実施
        /**********************************************************/
        callApiForGetDevicesInfo: async function(param){
            var queries = { live_access_token: this.$store.getters['auth/getLiveAccessToken'] };
            await this.$store.dispatch('requestApi/getApiInfoAction', {
                url: apiUrl + param,
                params: queries
            })
            .then(response => { // eslint-disable-line
                this.infoCallingApi = this.$store.getters['requestApi/getApiInfo'];
                this.deviceInfo = this.infoCallingApi;
                this.apiCnt++;
            }, error => {// eslint-disable-line
                // ローディングストップ
                this.$emit('loadFinish');
                if (error == "Error: Request failed with status code 401") {
                    sessionStorage.clear();
                    window.localStorage.removeItem('TodoApp');
                    this.showResultMessage({
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"エラー",
                        sub_message:"トップページに戻ります。",
                        errorFlag: true
                    });
                } else if (error == "Error: Request failed with status code 403") {
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: true,
                        execFlg: false,
                        message:"権限エラー",
                        sub_message:"アクセス権がありません。",
                        errorFlag: true
                    });
                } else {
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"カメラ詳細情報取得エラー",
                        sub_message:"カメラ詳細情報の取得に失敗しました。",
                        errorFlag: true
                    });
                }
            })
        },
        //**********************************************************/
        // タイムゾーン情報取得APIの実施
        /**********************************************************/
        callApiForGetTimezoneInfo: async function(param){
            var queries = { live_access_token: this.$store.getters['auth/getLiveAccessToken'] };
            await this.$store.dispatch('requestApi/getApiInfoAction', {
                url: apiUrl + param,
                params: queries
            })
            .then(response => { // eslint-disable-line
                this.infoCallingApi = this.$store.getters['requestApi/getApiInfo'];
                this.timezoneInfo = this.infoCallingApi;
                this.apiCnt++;
            }, error => {// eslint-disable-line
                // ローディングストップ
                this.$emit('loadFinish');
                if (error == "Error: Request failed with status code 401") {
                    sessionStorage.clear();
                    window.localStorage.removeItem('TodoApp');
                    this.showResultMessage({
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"エラー",
                        sub_message:"トップページに戻ります。",
                        errorFlag: true
                    });
                } else if (error == "Error: Request failed with status code 403") {
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: true,
                        execFlg: false,
                        message:"権限エラー",
                        sub_message:"アクセス権がありません。",
                        errorFlag: true
                    });
                } else {
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"カメラ詳細情報取得エラー",
                        sub_message:"カメラ詳細情報の取得に失敗しました。",
                        errorFlag: true
                    });
                }
            })
        },
        //**********************************************************/
        // 確認モーダル処理
        /**********************************************************/
        confirmFinished: function() {
            if (this.conrfirmResult.transitionLogoutPageFlg) {
                sessionStorage.clear();
                window.location.href = logoutUrl;
            }
            if (this.conrfirmResult.transitionTopPageFlg) {
                window.location.href = '/home?site_no=' + this.$store.getters['auth/getSiteNo'];
            }
            if (this.conrfirmResult.execFlg === true) {
                this.loadBrowser();
            }
        },
        //**********************************************************/
        // 確認モーダル用のデータの受け渡し
        /**********************************************************/
        showResultMessage: function(result) {
            this.$refs.Alert.showConfirm();
            this.alertMessage = result.message;
            this.alertSubMessage = result.sub_message;
            this.conrfirmResult = result
            this.errorFlag = result.errorFlag;
        },
        //**********************************************************/
        // 画面がリサイズされたらウィンドウの横幅を取得する
        /**********************************************************/
        handleResize: function() {
            this.windowSizeWidth = window.innerWidth;
            // semipoweruserで表示時に画面崩れが起きるので修正する
            // if(!this.$userRoleAuthorization('camSetting', 'settingCamRecOperation')) {
            //     if(this.windowSizeWidth < 1024) {
            //         $(`div.tr div.td.name`).removeClass(`pc`);
            //     } else {
            //         $(`div.tr div.td.name`).addClass(`pc`);
            //     }
            // }
        },
    },
    watch: {
        apiCnt: {
            handler: function() {
                if(this.apiCnt === 2) {
                    // document.getElementById('setting-area').style.display = "inherit"
                    this.requestErrorJudge = true;
                    /**********************************************************/
                    // 権限による録画開始・録画停止と状態が非表示になるときカメラ名称のwidth調整
                    // semipoweruserのときのみ適用
                    /**********************************************************/
                    // if(!this.$userRoleAuthorization('camSetting', 'settingCamRecOperation')) {
                    //     $(`div.tr div.td.name`).addClass(`pc`);
                    // }
                    this.$emit('loadFinish');
                }
            }
        }
    },
    computed: {
        /**********************************************************/
        // 権限による録画開始・録画停止と状態の表示非表示
        /**********************************************************/
        settingCamRecOperation() {
            return this.$userRoleAuthorization('camSetting', 'settingCamRecOperation');
        },
        /**********************************************************/
        // 権限によるカメラ直接操作の表示非表示
        /**********************************************************/
        settingCamOperation() {
            return this.$userRoleAuthorization('camSetting', 'settingCamOperation');
        },
    },
    created: function() {
        this.$emit('loadStart');
    },
    mounted: async function() {
        if(!this.$userRoleAuthorization('setting', 'settingCamLists')){
            // ローディングストップ
            this.$emit('loadFinish');
            this.showResultMessage({
                transitionLogoutPageFlg: false,
                transitionTopPageFlg: true,
                execFlg: false,
                message:"権限エラー",
                sub_message:"アクセス権がありません。",
                errorFlag: true
            });
        } else {
            // 機種情報などを取得してくるAPIを実施
            this.callApiForGetDevicesInfo('devices');
            // タイムゾーン情報などを取得してくるAPIを実施
            this.callApiForGetTimezoneInfo('timezone');
        }
        //**********************************************************/
        // resizeイベントが動作するときに実行する関数を登録(windowサイズを動的に取得)
        /**********************************************************/
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy: function() {
        window.removeEventListener('resize', this.handleResize);
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/main/SettingCamListsComponent.css";
</style>